import axios from 'axios';
import config from '@/config';
import store from './../index';
import * as types from './mutation-types';

const loginEndpoint = `${config.API_URL}/auth/token`;
const registerEndpoint = `${config.API_URL}/auth/register`;
const forgetPasswordEndpoint = `${config.API_URL}/auth/forgetpassword`;
const resetPasswordEndpoint = `${config.API_URL}/auth/resetpassword`;
const accountEndpoint = `${config.API_URL}/me`;
const clientEndpoint = `${config.API_URL}/Clients`;
const monitoringEndpoint = `${config.API_URL}/Monitorings`;

export const login = ({ commit, dispatch }, { email, password, rememberMe }) =>
  new Promise(resolve => {
    axios
      .post(loginEndpoint, { email: email, password: password })
      .then(response => {
        const user = response.data;
        commit(types.SET_APIKEY, {
          token: user.accessToken,
          rememberMe,
          expiredPassword: user.expiredPassword,
          newPasswordVerificationToken: user.newPasswordVerificationToken,
        });
        dispatch('getUser');
        resolve(response);
      })
      .catch(error => {
        resolve(error.request);
      });
  });

export const logout = ({ commit }) =>
  new Promise(resolve => {
    commit(types.LOG_OUT);
    resolve();
  });

export const register = (_, { token, password, legalAccepted }) =>
  new Promise(resolve => {
    axios
      .post(registerEndpoint, { token: token, password: password, legalAccepted: legalAccepted })
      .then(async response => {
        resolve(response.data);
      })
      .catch(error => {
        resolve(error.response);
      });
  });

export const forgetPassword = (_, { email }) =>
  new Promise((resolve, reject) => {
    axios
      .post(`${forgetPasswordEndpoint}`, { email })
      .then(async response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });

export const resetPassword = (_, { token, password }) =>
  new Promise((resolve, reject) => {
    axios
      .put(resetPasswordEndpoint, { token: token, password: password })
      .then(async response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getUser = ({ commit }, token) =>
  new Promise((resolve, reject) =>
    axios
      .get(accountEndpoint, { headers: { Authorization: `Token ${!token ? store.getters.apikey : token}` } })
      .then(response => {
        const user = response.data;
        if (token) commit(types.SET_APIKEY, { token });
        commit(types.SET_USER_INFO, user);
        commit(types.SET_LOGGED_IN, user);
        resolve(user);
      })
      .catch(err => {
        commit(types.LOG_OUT);
        reject(err);
      }),
  );

export const getHomeInfos = () =>
  new Promise((resolve, reject) =>
    axios
      .get(`${monitoringEndpoint}/metrics`, { headers: { Authorization: `Token ${store.getters.apikey}` } })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      }),
  );

export const editUser = (_, { id, firstName, lastName, activated, isMainUser, legalAccepted }) =>
  new Promise((resolve, reject) =>
    axios
      .patch(
        `${clientEndpoint}/users/${id}`,
        { firstName, lastName, activated, isMainUser, legalAccepted },
        { headers: { Authorization: `Token ${store.getters.apikey}` } },
      )
      .then(response => {
        const result = response.data;
        resolve(result);
      })
      .catch(err => {
        reject(err);
      }),
  );

export const disableUser = (_, { id, userToTransferId }) =>
  new Promise((resolve, reject) =>
    axios
      .patch(`${clientEndpoint}/users/${id}/disable`, { userToTransfer: userToTransferId }, { headers: { Authorization: `Token ${store.getters.apikey}` } })
      .then(response => {
        const result = response.data;
        resolve(result);
      })
      .catch(err => {
        reject(err);
      }),
  );

export const trySilentLogin = ({ commit, dispatch }) =>
  new Promise(resolve => {
    const userInfoStr = localStorage.getItem('userInfo');

    const userInfo = JSON.parse(userInfoStr);
    if (!userInfoStr || !userInfo) {
      resolve(false);
      return;
    }

    if (userInfo.apikey) {
      commit(types.SET_APIKEY, {
        token: userInfo.apikey,
        expiredPassword: userInfo.expiredPassword || false,
        newPasswordVerificationToken: userInfo.newPasswordVerificationToken || null,
      });
    }

    commit(types.SET_USER_INFO, userInfo.account);

    dispatch('getUser').then(() => resolve(true));
  });

export const contactInfogreffe = (_, { user, message, captchaResponse }) =>
  new Promise((resolve, reject) =>
    axios
      .post(`${config.API_URL}/Contact`, { user, message }, { headers: { 'X-Challenge': captchaResponse } })
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      }),
  );

export const patchLegalAcceptance = ({ getters }, { legalAccepted }) =>
  new Promise(resolve => {
    axios
      .patch(accountEndpoint, { legalAccepted }, { headers: { Authorization: `Token ${getters.apikey}` } })
      .then(async response => {
        resolve(response.data);
      })
      .catch(error => {
        resolve(error.response);
      });
  });

export const clearExpiredPassword = ({ commit }) =>
  new Promise(resolve => {
    commit(types.CLEAR_EXPIRED_PASSWORD);
    resolve();
  });
